module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Password reset"},"et":{"title":"Password reset"},"ru":{"title":"Password reset"}}')
  delete Component.options._Ctor
}
